// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Kyees","top":"styles_top__2iPng","left":"styles_left__2k2ce","description":"styles_description__htAyq"};